const WEBP_PROBE_SRC = 'data:image/webp;base64,UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==';

let webpSupportPromise: Promise<boolean> | null = null;

export const supportsWebp = (): Promise<boolean> =>
  (webpSupportPromise ??= new Promise((resolve) => {
    const probe = new Image();
    probe.onload = () => resolve(probe.width === 1);
    probe.onerror = () => resolve(false);
    probe.src = WEBP_PROBE_SRC;
  }));
